import { Box, Button, Flex, Option, Select, Text } from '@modusign/design-system';

import { Survey } from '@app/containers/Modal/WelcomeSurveyModal';
import {
  COMPANY_CATEGORIES,
  COMPANY_SCALES,
  DEPARTMENTS,
} from '@app/containers/Modal/WelcomeSurveyModal/fixtures';

interface CompanyScaleStepProps {
  nextStep: () => void;
  survey: Survey;
  setSurvey: (update: (survey: Survey) => Survey) => void;
}

function CompanyScaleStep({ nextStep, survey, setSurvey }: CompanyScaleStepProps) {
  const isFormValid = !!survey.companyScale && !!survey.department && !!survey.companyCategory;

  return (
    <>
      <Box fontSize={2} fontWeight="medium" mt={2}>
        비즈니스 정보에 맞는 모두싸인으로 설정해드릴게요.
      </Box>
      <Box mt={8}>
        <Box>
          <Text fontWeight="medium">규모</Text>
        </Box>
        <Box mt={3}>
          <Select
            color={survey.companyScale ? undefined : 'textNeutralVeryLight'}
            height="44px"
            required
            value={survey.companyScale}
            onChange={({ currentTarget }) =>
              setSurvey((prev) => ({ ...prev, companyScale: currentTarget.value }))
            }
          >
            <Option disabled value="">
              규모를 선택해 주세요.
            </Option>
            {COMPANY_SCALES.map((value) => (
              <Option key={value}>{value}</Option>
            ))}
          </Select>
        </Box>
        <Box mt={7}>
          <Text fontWeight="medium">부서</Text>
        </Box>
        <Box mt={3}>
          <Select
            color={survey.department ? undefined : 'textNeutralVeryLight'}
            height="44px"
            required
            value={survey.department}
            onChange={({ currentTarget }) =>
              setSurvey((prev) => ({ ...prev, department: currentTarget.value }))
            }
          >
            <Option disabled value="">
              부서를 선택해 주세요.
            </Option>
            {DEPARTMENTS.map((value) => (
              <Option key={value}>{value}</Option>
            ))}
          </Select>
        </Box>
        <Box mt={7}>
          <Text fontWeight="medium">산업군</Text>
        </Box>
        <Box mt={3}>
          <Select
            color={survey.companyCategory || 'textNeutralVeryLight'}
            height="44px"
            required
            value={survey.companyCategory}
            onChange={({ currentTarget }) =>
              setSurvey((prev) => ({ ...prev, companyCategory: currentTarget.value }))
            }
          >
            <Option disabled value="">
              산업군을 선택해 주세요.
            </Option>
            {COMPANY_CATEGORIES.map((value) => (
              <Option key={value}>{value}</Option>
            ))}
          </Select>
        </Box>
        <Flex alignItems="center" justifyContent="end" mt={9}>
          <Button disabled={!isFormValid} ml={6} variant="primary" onClick={nextStep}>
            다음
          </Button>
        </Flex>
      </Box>
    </>
  );
}

export default CompanyScaleStep;
